/*
 * @Author: your name
 * @Date: 2022-01-04 17:09:31
 * @LastEditTime: 2022-03-07 16:30:27
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \jeecg-boot\ant-design-vue-jeecg\src\utils\validate.js
 */
/**
 * 邮箱
 * @param {*} s
 */
export function isEmail(s) {
  return /^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(s)
}

/**
 * 手机号码
 * @param {*} s
 */
export function isMobile(s) {
  return /^1[0-9]{10}$/.test(s)
}

/**
 * 电话号码
 * @param {*} s
 */
export function isPhone(s) {
  return /^([0-9]{3,4}-)?[0-9]{7,8}$/.test(s)
}

/**
 * URL地址
 * @param {*} s
 */
export function isURL(s) {
  return /^http[s]?:\/\/.*/.test(s)
}

// 判断是否是中文
export const _isChn = (str) => {
  return /^[^\u4e00-\u9fa5]+$/.test(str)
}

// 非法字符判断
export const _isIllegal = (str) => {
  return /[\\\\/:*?\\"<>|]/im.test(str)
}

export const regTestControl = (str) => {
  return /^[\u4e00-\u9fa5_a-zA-Z0-9- '‘’”“"]+$/.test(str)
}
